export const variableConstant = {
  incorrectPassword: "Incorrect password",
  incorrectEmail: "Incorrect UserId",
  loginTitle: "Login",
  forgetPasswordTitle: "Forget Password",
  loginButtonText: "Login",
  forgetPasswordLink: "Forgot Password?",
  goToLogin: "Go Back to Login",
  reset: "Reset",
  resetPassword: "Reset Password",
  chagePassword: "Change Password",
  createUser: "Create",
  required: "* Required",
  myProfile: "My Profile",
  firstName: "First Name:",
  lastName: "Last Name:",
  middleName: "Middle Name",
  emailAddress: "Email Address:",
  userId: "User Id:",
  department: "Department:",
  summary: "Summary",
  financials: "Financials",
  premium: "Premium",
  drivers: "Drivers",
  vehicles: "Vehicles",
  ratingInfo: "Rating Info",
  documents: "Documents",
  notes: "Notes",
  addtionalInfo: "Additional Info",
  effectiveDate: "Effective Date",
  priorNo: "Prior No",
  annualExpiration: "Annual?",
  priorCompany: "Prior Company",
  previousExpiration: "Previous Expiration",
  approvedBy: "Approved by",
  priorBI: "Prior Bl",
  dateBound: "Date Bound",
  policyStatus: "Status",
  lapse: "Lapse",
  none: "none",
  oneTo10: "1-10",
  elevenTOthirtyOne: "11-31",
  priorCov: "Prior Cov?",
  bl: "Bl?",
  priorBal: "Prior Bal?",
  policyInfo: "Policy Info",
  warnings: "Warnings",
  insuredInfo: "Insured Info",
  firstInsured: "1st Insured",
  samemailingAddress: "Mailing address is same",
  secondInsured: "2nd Insured",
  mailingAddress: "Mailing Address",
  garageAddress: "Garage Address",
  city: "City",
  state: "State",
  zip: "Zip",
  email: "Email",
  garagedCounty: "Garage County",
  paperless: "Paperless",
  teritorry: "Teritorry",
  county: "County",
  newDriverForm: "New Driver ",
  driverInfo: "Driver Info",
  licensedState: "Licensed State",
  licensed: "License #",
  dateLicensed: "Date Licensed",
  suffix: "Suffix",
  case: "Case",
  dob: "DOB",
  creditScore: "Credit Score",
  gender: "Gender",
  male: "Male",
  female: "Female",
  international: "International",
  suspended: "Suspended",
  unverifiable: "Unverifiable",
  sr22: "SR-22",
  married: "Married",
  yes: "Yes",
  no: "No",
  relatedToInsure: "Related to insured",
  employementInfo: "Employement Info",
  jobTitle: "Job Title",
  company: "Company",
  workPhone: "Work Phone",
  discounts: "Discounts",
  options: "Options",
  seniorDef: "Senior Defense Driver Discount",
  incepDate: "Inception Date",
  safeDriverDiscount: "Safe Driver Discount",
  excluded: "Excluded",
  vehicleInfo: "Vehicle Info",
  vin: "VIN",
  ars: "ARS",
  year: "Year",
  atd: "ATD",
  make: "Make",
  abs: "ABS",
  convertible: "Convertible",
  fourk4: "4k4",
  modeltwo: "Model 2",
  drl: "DRL",
  hybrid: "Hybrid",
  noDoors: "No Doors",
  costNew: "Cost New",
  noCyc: "No. Cyc",
  amountCustomized: "Amount Customized",
  drive: "Drive",
  vehicleSymbols: "Vehicle Symbols",
  iso: "ISO",
  coll: "COLL",
  agicBi: "BI",
  um: "UM",
  pd: "PD",
  mp: "MP",
  comp: "COMP",
  vehicleCoverageInfo: "Vehicle Coverage Info",
  principleOperator: "Principle Operator",
  businessuse: "Business Use",
  artaan: "Artisan",
  phyDan: "Phy Dam?",
  tenMiles: ">10 miles to work",
  compDeduct: "COMP Deduct",
  leinHolders: "Lien Holders & Additional Interest",
  name: "Name",
  address: "Address",
  addInterest: "Add Interest",
  phone: "Phone",
  coverageInfo: "Coverage Info",
  pipDeductible: "PIP Deductible",
  compDed500: "Comp Ded:500",
  collDed500: "Coll Ded 500",
  bodlilyInjuryLimits: "Bodily Injury Limits",
  paperlessDiscounts: "Paperless Discount?",
  advQuotaDiscount: "Advanced Quote Discount?",
  currCustomerDiscount: "Current Customer Discount?",
  homwOwnersDiscount: "Homeowners Discounts?",
  ppo: "PPO?",
  experianceDrivers: "Experience Driver Credit",
  unLimits: "UN Limits",
  workLoassExclusion: "Work Loss Exclusion",
  excludeWorkLoss: "Exclude Work Loss",
  nio: "NIO",
  nirr: "NIRR",
  billingOptions: "Billing Options",
  paymentPlan: "Payment Plan",
  paidInFullDiscounts: "Paid In Full Discount?",
  recurringEFTDiscounts: "Recurring EFT Discount?",
  renewalDiscounts: "Renewal Discount",
  payments: "Payments",
  user: "User",
  date: "Date",
  time: "Time",
  userInfo: "User Information",
  producerInfo: "Producer Info",
  updateUser: "update",
  title: "Title:",
  unacceptable: "Unacceptable Risk",
  territory: "Territory",
  isIneligible: "Ineligible",
};
